var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CustomerList"},[_c('div',{staticClass:"serve-box"},[_c('div',{staticClass:"title"},[_vm._v("客服")]),_c('div',{staticStyle:{"font-weight":"600"}},[_vm._v("\n      商家名称：海礼网（北京）智能技术有限公司\n    ")]),_c('div',{staticClass:"tel-box",on:{"click":_vm.handleCall}},[_c('div',[_vm._v("客服电话")]),_c('div',[_vm._v("服务时间：09:00——18:00")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }